import React, { useState } from "react";
import { Link } from "react-router-dom";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/free-solid-svg-icons";
import styled from "styled-components";
import ConfigurationBarWrapper from "./ConfigurationBarWrapper";

const AUTOPLAY_BANNER_DISMISSED_KEY = "chim_jukebox_autoplay_banner_dismissed";

export const Wrapper = styled.section`
  .linkPlay {
    position: relative;
  }
  .play {
    font-size: 12px;
    top: 4px;
    position: absolute;
  }
  .backward {
    margin-right: 10px;
  }
  .home-settings {
    /* config buttons */
    button {
      padding: 6px 12px;
      border: 1px solid #333;
      margin-right: 4px;
      &:last-of-type {
        margin-right: 0px;
      }
    }
  }
  .setting-text {
    font-size: 13px;
    line-height: 14px;
    margin-top: 4px;
    label {
      &:hover {
        cursor: pointer;
      }
    }
  }
  .home-settings-open {
    position: absolute;
    right: 0;
    z-index: 1;
    border: 1px solid #666;
    background-color: #ccc;
    padding: 15px 16px 0px 10px;
  }
  .jukebox-autoplay-banner {
    display: flex;
    align-items: flex-start;
    gap: 12px;
    background-color: #ffd487;
    border: 1px solid #ccc;
    padding: 10px 12px;
    margin: 4px 0 16px;
    font-size: 14px;
    line-height: 1.45;
    color: #222;

    p {
      margin: 0;
      flex: 1;
    }

    button {
      flex: 0 0 auto;
      background: transparent;
      border: none;
      padding: 0 2px;
      line-height: 1;
      color: #333;
      cursor: pointer;
    }

    .banner-gear {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      width: 22px;
      height: 22px;
      margin: 0 3px;
      border: 1px solid #333;
      background: #fff;
      font-size: 12px;
      vertical-align: middle;
    }
  }
`;

function HomeHeader(props) {
  const { date, daysAgo, settings } = props;
  const next = parseInt(daysAgo, 10) - 1;
  const prev = parseInt(daysAgo, 10) + 1;
  const [bannerDismissed, setBannerDismissed] = useState(
    () => localStorage.getItem(AUTOPLAY_BANNER_DISMISSED_KEY) === "true"
  );
  const showAutoplayBanner =
    daysAgo === 0 && !bannerDismissed && (!settings.playInJukebox || !settings.autoplayInJukebox);

  const dismissAutoplayBanner = () => {
    localStorage.setItem(AUTOPLAY_BANNER_DISMISSED_KEY, "true");
    setBannerDismissed(true);
  };

  return (
    <Wrapper>
      {showAutoplayBanner && (
        <div className="jukebox-autoplay-banner" role="status">
          <p>
            Tracks can auto-play in the jukebox at the bottom of the page. Open the settings{" "}
            <span aria-hidden="true">
              <FontAwesomeIcon icon="cog" />
            </span>{" "} on the right
            to turn this on.
          </p>
          <button type="button" onClick={dismissAutoplayBanner} aria-label="Close" title="Close">
            <FontAwesomeIcon icon={faTimes} />
          </button>
        </div>
      )}
      <Row noGutters>
        <Col xs={6} sm={8} md={9}>
          {daysAgo === 0 && (
            <div className="home-header">
              <h2>Today's Tracks</h2>
            </div>
          )}
          {daysAgo !== 0 && (
            <div className="home-header">
              <h2>Tracks Rewind</h2>
              <div>{date}</div>
              {prev > 0 && (
                <span>
                  <Link to={`/rewind/${prev}`}>
                    <FontAwesomeIcon title="Back a day" icon="backward" className="backward" />
                  </Link>
                </span>
              )}
              {next == 0 && (
                <span>
                  <Link to={`/`} className="linkPlay">
                    <FontAwesomeIcon title="Today" icon="play" className="play" />
                  </Link>
                </span>
              )}
              {next > 0 && (
                <span>
                  <Link to={`/rewind/${next}`}>
                    <FontAwesomeIcon title="Forward a day" icon="forward" className="forward" />
                  </Link>
                </span>
              )}
            </div>
          )}
        </Col>
        <Col xs={6} sm={4} md={3} className="home-settings text-right">
          <ConfigurationBarWrapper {...props} />
        </Col>
      </Row>
    </Wrapper>
  );
}

export default HomeHeader;
